import React from "react";
import { numberWithCommas } from "../../../utils/helpers/numberConverter";
import HelpCircleIcon from "../../HelpCircleIcon/HelpCircleIcon";
import DashboardItemProps from "./DashboardTopItemProps";

const DashboardItem = (props: DashboardItemProps) => {
  return (
    <div id={`dashboard-fund-item-${props.title}`} className="dashboard-fund-item" style={{ borderLeft: props.mobileHideLeftBorder ? 'none' : '' }} >
      <div className="dashboard-fund-item-text">
        <h2 className="dashboard-fund-item-title">{props.title}</h2>
        {props.toolTip ? <HelpCircleIcon label={props.toolTip} /> : null}
      </div>
      <div className="fund-item-value-wrapper">
        {props.symbol === "₪" ? (
          <span className="dashboard-shekel">{props.symbol}</span>
        ) : null}
        <span className="dashboard-fund-item-value">
          { props.isToShowFully ? props?.value?.toFixed(2) : numberWithCommas(Math.floor(props.value || 0))}
        </span>

        {props.month ? (
          <span className="dashboard-bottom-month">{props.month} </span>
        ) : null}
        {props.symbol === "%" ? (
          <span className="dashboard-shekel">{props.symbol}</span>
        ) : null}
      </div>
      <div className="fund-item-bottom-wrapper">
        <span className="dashboard-fund-item-bottom">{props.subString}</span>
      </div>
    </div >
  );
};

export default DashboardItem;
